import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { PlanillaPartidoJugador, PlanillaPartidoJugadorJSON } from './PlanillaPartidoJugador';
export class PlanillaPartidoJugadorSystem {
  private readonly base = '/planillapartidojugadors';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getPlanillaPartidoJugadorIdentifiedBy(id: string): Promise<PlanillaPartidoJugador> {
    const data = await this.requestHandler.get<PlanillaPartidoJugadorJSON>(`${this.base}/${id}`);
    return PlanillaPartidoJugador.fromJSON(data);
  }

  async getList(): Promise<PlanillaPartidoJugador[]> {
    const data = await this.requestHandler.get<PlanillaPartidoJugadorJSON[]>(`${this.base}`);
    return data.map((entity) => PlanillaPartidoJugador.fromJSON(entity));
  }

  async getListForDropdown(): Promise<PlanillaPartidoJugador[]> {
    const data = await this.requestHandler.get<PlanillaPartidoJugadorJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => PlanillaPartidoJugador.fromJSON(entity));
  }

  async save(jugador: PlanillaPartidoJugador): Promise<PlanillaPartidoJugador> {
    const data = jugador.toJSON();

    try {
      const savedEntity = await this.requestHandler.post<
        PlanillaPartidoJugadorJSON,
        PlanillaPartidoJugadorJSON
      >(this.base, data);

      jugador.setHasPengingChanges(false);
      return PlanillaPartidoJugador.fromJSON(savedEntity);
    } catch (error) {
      jugador.setHasPengingChanges(true);
      throw error;
    }
  }

  async saveFromPlanilla(entity: PlanillaPartidoJugador, torId: string) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<
      PlanillaPartidoJugadorJSON,
      { planillaPartidoJugador: PlanillaPartidoJugadorJSON; torneoId: string }
    >(`${this.base}/agregar-jugador-from-planilla`, { planillaPartidoJugador: data, torneoId: torId });
    return PlanillaPartidoJugador.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
